import moment from 'moment'
import { i18n } from '@/locale'
import { getTimeFormat } from '@/lib/helpers/HoursFormatter'

moment.locale(i18n.locale)

/**
 * 
 * @param {String} date 
 * @param {String} size Can be 'sm' to short date or 'xl'
 * @param {Booelan} showYear Decide to show year or not
 * @returns A moments date
 */
function displayFormatDate (date, size, showYear) {
  let format
  moment.locale(i18n.locale)
  if (moment.locale() === 'es') {
    format = size === 'sm' ?
      showYear ? 'D MMM YYYY' : 'DD MMM' :
      showYear ? 'D MM, YYYY' : 'DD MMMM'
  }
  else {
    format = size === 'sm' ?
      showYear ? 'MMM D, YYYY' : 'MMM Do' :
      showYear ? 'MMMM D, YYYY' : 'MMMM Do'
  }
  return formatDate(date, format)
}

/**
 * 
 * @param {String} date 
 * @param {Booelan} showYear Decide to show year or not
 * @returns A moments date
 */
function displayFormatDateAndHour (date, showYear) {
  moment.locale(i18n.locale)
  const timeFormat = getTimeFormat()
  if (moment.locale() === 'es') {

    return showYear ? 
      moment(date).format(`DD MMMM YYYY ${ timeFormat }`) :
      moment(date).format(`DD MMMM ${ timeFormat }`)
  }
  return showYear ? 
    moment(date).format(`MMMM Do YYYY ${ timeFormat }`) :
    moment(date).format(`MMMM Do ${ timeFormat }`)
}

function formatDate (date, format) {
  moment.locale(i18n.locale)
  return moment(date).format(format)
}

function isBeforeYear (date) {
  return moment(date).year() < moment().year()
}

export {
  displayFormatDate,
  displayFormatDateAndHour,
  isBeforeYear,
}